import { TaxReferenceType } from "../../../../../../Wrap/Constants/Enums/Customer/TaxReferenceType";
import { CountryCode } from "../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { ActorType } from "../../../../../../Wrap/Constants/Enums/Customer/ActorType";

export const CountryWithoutIdentifier = [
    CountryCode.AUT,
    CountryCode.DEU,
    CountryCode.FRA,
    CountryCode.HUN,
    CountryCode.IRL,
    CountryCode.LUX,
];

export const CountryWithPPThenID = [CountryCode.LIE, CountryCode.NLD];

export const CountryWithIDThenPP = [
    CountryCode.CZE,
    CountryCode.LTU,
    CountryCode.MLT,
    CountryCode.ROU,
    CountryCode.SVK,
];

export const CountryWithTXOnly = [CountryCode.ESP, CountryCode.GBR, CountryCode.ITA];

export const CountryWithIDOnly = [
    CountryCode.BEL,
    CountryCode.BGR,
    CountryCode.DNK,
    CountryCode.EST,
    CountryCode.FIN,
    CountryCode.GRC,
    CountryCode.HRV,
    CountryCode.ISL,
    CountryCode.LVA,
    CountryCode.NOR,
    CountryCode.SWE,
    CountryCode.SLV,
];

export const CountryWithIDThenTX = [CountryCode.POL];

export const CountryWithTXThenPP = [CountryCode.PRT];

export interface INationalityConfig {
    priority: number;
    Type: string;
    title?: string;
    mandatory: boolean;
    key: string;
}

export class RegulatoryHelper {
    static getTaxReferenceTypes(actorType: ActorType, country?: CountryCode) {
        if (country == CountryCode.USA) {return TaxReferenceTypes_USA;}
        if (country == CountryCode.GBR) {return actorType == ActorType.Organisation ? TaxReferenceTypes_GBR_Company : TaxReferenceTypes_GBR_Individual;}
        if (country == CountryCode.SGP) {return TaxReferenceTypes_SGP;}
        return null;
    }

    static getTaxReferenceTypeMap(country?: CountryCode) {
        if (country == CountryCode.USA) {return TaxReferenceTypeMap_USA;}
        if (country == CountryCode.GBR) {return TaxReferenceTypeMap_GBR;}
        if (country == CountryCode.SGP) {return TaxReferenceTypeMap_SGP;}
        return null;
    }
    static getDefaultTaxReferenceType(country?: CountryCode) {
        return Number(country.toString() + "0");
    }
}

export const TaxReferenceTypes_USA = [
    TaxReferenceType.UsaSsn,
    TaxReferenceType.UsaItin,
    TaxReferenceType.UsaAtin,
    TaxReferenceType.UsaEin,
];
export const TaxReferenceTypeMap_USA = {
    [TaxReferenceType.UsaSsn]: "Social Security Number",
    [TaxReferenceType.UsaItin]: "Individual Taxpayer Identification Number",
    [TaxReferenceType.UsaAtin]: "Adoptions Tax Identification Number",
    [TaxReferenceType.UsaEin]: "Employer Identification Number",
};

export const TaxReferenceTypes_GBR_Individual = [TaxReferenceType.GbrNino];
export const TaxReferenceTypes_GBR_Company = [TaxReferenceType.GbrNino, TaxReferenceType.GbrUtr];
export const TaxReferenceTypeMap_GBR = {
    [TaxReferenceType.GbrNino]: "National Insurance Number",
    [TaxReferenceType.GbrUtr]: "Unique Taxpayer Reference",
};

export const TaxReferenceTypes_SGP = [TaxReferenceType.SgpNric, TaxReferenceType.SgpFin];
export const TaxReferenceTypeMap_SGP = {
    [TaxReferenceType.SgpNric]: "National Registration Identity Card",
    [TaxReferenceType.SgpFin]: "National Registration Identity Card For Foreigners",
};

export const TaxReferenceTypeMap = {
    [TaxReferenceType.SgpNric]: "National Registration Identity Card",
    [TaxReferenceType.SgpFin]: "National Registration Identity Card For Foreigners",
    [TaxReferenceType.GbrNino]: "National Insurance Number",
    [TaxReferenceType.GbrUtr]: "Unique Taxpayer Reference",
    [TaxReferenceType.UsaSsn]: "Social Security Number",
    [TaxReferenceType.UsaItin]: "Individual Taxpayer Identification Number",
    [TaxReferenceType.UsaAtin]: "Adoptions Tax Identification Number",
    [TaxReferenceType.UsaEin]: "Employer Identification Number",
    [TaxReferenceType.EspTin]: "Código de identificación fiscal",
};
